import { IUnit } from "../interfaces/unit";



export class TorqueUnits {
  static kgfm: IUnit = { id: 0, display: 'KGFM' };
  static ftlb: IUnit = { id: 1, display: 'ft-lb' };
  static nm: IUnit = { id: 2, display: 'Nm' };

  static getById(id: number) {
    let values = Object.values(TorqueUnits);
    return values[id];
  }

  static torqueTolbft(torque: number, torqueUnits: string): number {
    switch (torqueUnits) {
      case TorqueUnits.kgfm.display:
        return torque * 7.23301;
        break;
      case TorqueUnits.nm.display:
        return torque / 1.356;
        break;
      default:
        return torque;
        break;
    }
  }

  static lbftToTorque(torque: number, torqueUnits: string): number {
    switch (torqueUnits) {
      case TorqueUnits.kgfm.display:
        return torque / 7.23301;
        break;
      case TorqueUnits.nm.display:
        return torque * 1.356;
        break;
      default:
        return torque;
        break;
    }
  }
}
